export default "__VITE_ASSET__BeB_3QX6__"